import { Button, Card, Input, Typography, message } from "antd";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { IndianRupee } from "lucide-react";
import { TelenganaApiService } from "../httpsservice/ApiService";
import { formatDate } from "../utils";

const { Text } = Typography;

const BillCard = ({ billData }) => {
  const [payableAmount, setPayableAmount] = useState("");
  const [isPayloading, setPayLoader] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const [disableAmountInput, setDisableAmountInput] = useState(false);

  useEffect(() => {
    const handleBFCache = (event) => {
      if (event.persisted) {
        window.location.reload();
      }
    };
    window.addEventListener("pageshow", handleBFCache);
    return () => window.removeEventListener("pageshow", handleBFCache);
  }, []);

  useEffect(() => {
    if (billData) {
      if (billData?.totalAmount && billData?.totalAmount > 0) {
        setPayableAmount(`${billData.totalAmount}`);
        setDisableAmountInput(true);
      } else if (billData.amountPayable > 0) {
        setPayableAmount(`${billData.amountPayable}`);
      } else {
        setPayableAmount("");
      }
    }
  }, [billData]);

  const handleAmountChange = (e) => {
    let amount = e.target.value
      .replace(/[^\d.]/g, "") // Remove all non-digit, non-dot
      .replace(/\.{2,}/g, ".") // Replace multiple dots with one
      .replace(/^(\d*\.\d*).*$/, "$1"); // Allow only the first decimal

    setPayableAmount(amount);
  };

  const handlePayment = () => {
    if (
      !payableAmount ||
      payableAmount.trim() === "" ||
      isNaN(payableAmount) ||
      Number(payableAmount) <= 0
    ) {
      messageApi.error("Please enter a valid payable amount!");
    } else if (
      billData.amountPayable > 0 &&
      Number(payableAmount) < billData.amountPayable
    ) {
      messageApi.error(
        `Amount should be equal or more than ${billData.amountPayable} INR`,
      );
    } else if (Number(payableAmount) > 10000000) {
      messageApi.error(`Amount cannot be greater than 10000000 INR`);
    } else {
      pay();
    }
  };

  const pay = async () => {
    setPayLoader(true);
    const queryData = {
      txn_id: billData?.txnId,
      amount: payableAmount,
    };
    const response = await TelenganaApiService.payBill(queryData);
    if (response.success) {
      window.location.href = response.redirect_url;
    } else {
      messageApi.error(
        response?.data?.message ||
          `Failed to submit bill payment. Please try again after sometime.`,
      );
      if (
        response?.data?.message?.toLowerCase().trim() ===
        "transaction not found"
      ) {
        window.location.reload();
      }
      // window.location.href = "/TGSPDCL/Billpay";
    }
    setPayLoader(false);
  };

  const handelBackPress = () => {
    window.location.href = "/TGSPDCL/Billpay";
    setPayableAmount("");
  };

  return (
    <div className="bill">
      {contextHolder}
      <div className="tel-logo-main">
        <img
          alt="BSES"
          className="tgspdcl-logo"
          src="https://ebz-static.s3.ap-south-1.amazonaws.com/layer/tgspdcl-logo.jpg"
        />

        <span className="elecricity-title inner-title">
          SOUTHERN POWER DISTRIBUTION COMPANY OF TELANGANA LIMITED
        </span>
        {/* <img
          alt="Bank Logo"
          className="bob-logo"
          src="https://ebz-static.s3.ap-south-1.amazonaws.com/layer/Federal_bank.svg"
        /> */}
      </div>
      <p className="table-head">Payment details for {billData.serviceType}</p>
      <div className="content-header">
        <div className="table-main-tg">
          <Card className="service-number-card-internal">
            <table className="table">
              <tbody>
                <tr>
                  <td className="column">Unique Service Number:</td>
                  <td>{billData?.uniqueSNo || "N/A"}</td>
                </tr>
                <tr>
                  <td className="column">Service Number:</td>
                  <td>{billData?.serviceNo || "N/A"}</td>
                </tr>
                <tr>
                  <td className="column">Name:</td>
                  <td>{billData?.customerName || "N/A"}</td>
                </tr>
                <tr>
                  <td className="column">ERO:</td>
                  <td>{billData?.eroCode || "N/A"}</td>
                </tr>
                <tr>
                  <td className="column">Bill Date:</td>
                  <td>{formatDate(billData?.billDate) || "N/A"}</td>
                </tr>
                <tr>
                  <td className="column">Due Date:</td>
                  <td>{formatDate(billData?.dueDate) || "N/A"}</td>
                </tr>
                <tr>
                  <td className="column">Bill Amount:</td>
                  <td>
                    ₹{" "}
                    {billData?.totalAmount
                      ? parseFloat(billData?.totalAmount).toFixed(2)
                      : "0.00"}
                  </td>
                </tr>
                <tr>
                  <td className="column">ACD Amount:</td>
                  <td>
                    ₹{" "}
                    {billData?.acdAmount
                      ? parseFloat(billData?.acdAmount).toFixed(2)
                      : "0.00"}
                  </td>
                </tr>
                <tr>
                  <td className="column">Reconnection Fee:</td>
                  <td>
                    ₹{" "}
                    {billData?.reconnectionFee
                      ? parseFloat(billData?.reconnectionFee).toFixed(2)
                      : "0.00"}
                  </td>
                </tr>
                <tr>
                  <td className="column"> Payment Amount:</td>
                  <td>
                    <strong>
                      ₹{" "}
                      {billData.amountPayable
                        ? parseFloat(billData.amountPayable).toFixed(2)
                        : "0.00"}
                    </strong>
                  </td>
                </tr>
              </tbody>
            </table>

            <div className="amount-input-container">
              <table className="table">
                <tr>
                  <td className="column">
                    Amount: <span style={{ color: "red" }}>*</span>
                  </td>
                  <td>
                    <div className="amount-input-wrapper">
                      <IndianRupee className="rupee-icon" size={14} />
                      <Input
                        type="text"
                        placeholder="Enter Amount"
                        value={payableAmount}
                        onChange={handleAmountChange}
                        className="amount-input"
                        disabled={disableAmountInput}
                      />
                    </div>
                  </td>
                </tr>
              </table>
            </div>
          </Card>
          <Button
            className="fetch-bill-btn-tg "
            size="large"
            block
            onClick={handlePayment}
            loading={isPayloading}
          >
            Submit Payment
          </Button>
          <Link
            className="back-bill-btn"
            size="large"
            type="link"
            block
            onClick={handelBackPress}
          >
            Back
          </Link>
        </div>

        <div className="charges-container-main">
          <Card className="trxn-service-chargs-card-internal">
            <p className="charges-title">Transaction Service Charges</p>
            <table className="charges-table">
              <tr>
                <td>RuPay Debit Cards & UPI</td>
                <td>Nil</td>
              </tr>
              <tr>
                <td>Credit Cards</td>
                <td>0.64% of the Transaction Amount.</td>
              </tr>
              <tr>
                <td>Debit Cards (Visa/MasterCard/Maestro)</td>
                <td>0.60% of the Transaction amount.</td>
              </tr>
            </table>
            <span>
              <strong>Note: </strong>GST/Taxes applicable will be charged extra
              on the transaction fees.
            </span>
          </Card>
          <div className="amount-payable-alert-div">
            {billData.amountPayable <= 0 && (
              <p className="amount-payable-alert-msg">
                No bills pending for payment. Please enter amount for advance
                payment.
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BillCard;
